// extracted by mini-css-extract-plugin
export default {"dropzone":"fileUpload_dropzone__i-1kP","disabled":"fileUpload_disabled__3REme","is-over":"fileUpload_is-over__GIeYe"};